module.exports = __webpack_public_path__ + "static/media/x-ray.b22b31d5.svg";